export default __webpack_public_path__ + "static/media/violet.c334b819.png";